// extracted by mini-css-extract-plugin
module.exports = {"conculision_divider":"styles_conculision_divider__2gR42","question_body":"styles_question_body__3NzH9"};